import type { LabelHTMLAttributes, ReactElement } from 'react';
import { cn } from '../lib/utils';

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  readonly isRequired?: boolean;
}

export const Label = ({
  className,
  isRequired = false,
  children,
  ...props
}: LabelProps): ReactElement => (
  // biome-ignore lint/a11y/noLabelWithoutControl: htmlFor 는 호출측이 props 로 전달한다 (FormField 가 useId 로 연결).
  <label
    className={cn(
      'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
      className,
    )}
    {...props}
  >
    {children}
    {isRequired ? (
      <span className="ml-0.5 text-destructive" aria-hidden="true">
        *
      </span>
    ) : null}
  </label>
);
